import React, { useState, useEffect } from 'react';
import { useRestaurant } from '../../contexts/RestaurantContext.tsx';
import { Square, Circle, X } from 'lucide-react';
import '../../styles/table-editor.css'; // <<< reutiliza o mesmo CSS do TableEditor

interface ElementEditorProps {
  element: any;
  onSave: () => void;
}

const ElementEditor = ({ element, onSave }: ElementEditorProps) => {
  const { updateElement } = useRestaurant();

  const [elementName, setElementName] = useState(element.name);
  const [elementShape, setElementShape] = useState(element.shape); // 'square' | 'circle'
  const [elementColor, setElementColor] = useState(element.color || '#e9c46a');
  const [textColor, setTextColor] = useState(element.textColor || '#000000');

  // Mantém o comportamento de sincronizar quando trocar o elemento
  useEffect(() => {
    setElementName(element.name);
    setElementShape(element.shape);
    setElementColor(element.color || '#e9c46a');
    setTextColor(element.textColor || '#000000');

    // (Opcional) rolar até o botão salvar, igual no criador
    setTimeout(() => {
      const btn = document.querySelector('.btn-save') as HTMLElement;
      if (btn) btn.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }, 100);
  }, [element]);

  const handleSave = () => {
    updateElement(element.id, {
      name: elementName,
      shape: elementShape,
      color: elementColor,
      textColor
    });
    onSave();
  };

  return (
    <div className="table-editor">{/* reaproveita container e estilos */}
      <div className="editor-header">
        <h3>Configurações do Objeto</h3>
        <div className="header-actions">
          <button className="close-btn" onClick={onSave} title="Fechar">
            <X size={18} />
          </button>
        </div>
      </div>

      <div className="editor-form">
        <div className="form-group">
          <label htmlFor="element-name">Nome</label>
          <input
            id="element-name"
            type="text"
            value={elementName}
            onChange={(e) => setElementName(e.target.value)}
            placeholder="Nome do objeto"
            className="form-control"
          />
        </div>

        <div className="form-group">
          <label>Formato</label>
          <div className="shape-selector">
            <button
              className={`shape-btn ${elementShape === 'square' ? 'active' : ''}`}
              onClick={() => setElementShape('square')}
            >
              <Square size={28} />
            </button>
            <button
              className={`shape-btn ${elementShape === 'circle' ? 'active' : ''}`}
              onClick={() => setElementShape('circle')}
            >
              <Circle size={28} />
            </button>
          </div>
        </div>

        <div className="form-group">
          <label htmlFor="element-color">Cor do Elemento</label>
          <div className="color-input">
            <input
              id="element-color"
              type="color"
              value={elementColor}
              onChange={(e) => setElementColor(e.target.value)}
              className="form-control"
            />
          </div>
        </div>

        <div className="form-group">
          <label htmlFor="text-color">Cor do Texto</label>
          <div className="color-input">
            <input
              id="text-color"
              type="color"
              value={textColor}
              onChange={(e) => setTextColor(e.target.value)}
              className="form-control"
            />
          </div>
        </div>

        <button className="btn-save" onClick={handleSave}>
          Salvar
        </button>
      </div>
    </div>
  );
};

export default ElementEditor;
